import { atom } from "recoil";
import { localStorageEffect } from "./Utils";

export type PushNotificationsState = {
  isSubscribed: boolean;
};

export const pushNotificationsState = atom<PushNotificationsState>({
  key: "pushNotificationsState",
  default: { isSubscribed: false },
  effects: [localStorageEffect<PushNotificationsState>("pushNotificationsState")],
});
